module.exports = {
  PAGE_PROFILE_PERSONAL_DETAILS: 'profile_personal_details',
  PAGE_PROFILE_MY_PROFILE: 'myprofile',
  PAGE_PROFILE_QUESTIONS: 'profile_questions',
  PAGE_PROFILE_CHANGE_EMAIL: 'profile_personaldetails_changemail',
  PAGE_PROFILE_CHANGE_PASSWORD: 'profile_personaldetails_changepass',
  PAGE_PROFILE_CHANGE_PROFILE_IMAGE: 'profile_image_change',
  PAGE_PROFILE_MESSAGES: 'profile_messages',
  PAGE_USER_ALREADY_ORDERED: 'already_ordered',
  PAGE_PROFILE_ORDERS_VIEW: 'profile_orders_view',
  PAGE_HELPDESK: 'helpdesk',
  PAGE_PAYMENT: 'payment',
  PAGE_THANK_YOU: 'thank_you',
  PAGE_CHECKOUT: 'checkout',
  PAGE_CONFIRM_EMAIL_CHANGE: 'confirm_email_change',
  PAGE_CONFIRM_SUBSCRIPTION: 'confirm_confirm_subscription',
  PAGE_LEAD_SUBSCRIBER: 'lead_subscriber',
  PAGE_CONFIRM_MAIL_MASTER_SUBSCRIBE: 'confirm_mail_master_subscribe',
  PAGE_CONFIRM_PRODUCT_OPINION_EMAIL_UNSUBSCRIBE: 'confirm_product_opinion_email_unsubscribe',
  PAGE_CONFIRM_MAIL_MASTER_UNSUBSCRIBE: 'confirm_mail_master_unsubscribe',
  PAGE_SEARCH: 'search',
  PAGE_LOGIN: 'login',
  PAGE_PASSWORD_RECOVERY: 'password_recovery',
  PAGE_CHANGE_PASSWORD: 'change_password',
  PAGE_CATEGORY: 'category',
  PAGE_PRODUCT_QUESTIONS: 'questions',
  PAGE_PRODUCT_COMPOSITIONS: 'compositions',
  PAGE_PRODUCT_PRODUCT: 'product',
  PAGE_PRODUCT_REVIEWS: 'reviews',
  PAGE_BRAND: 'brand',
  PAGE_ARTICLE: 'article',
  PAGE_ARTICLE_NO_RULE: 'article_no_rule',
  PAGE_MEAL_COMPONENT: 'meal_component',
  PAGE_PRODUCT_TEST: 'product_test',
  PAGE_HOME: 'home',
  PAGE_SCITEC_LANDING: 'scitec_lading',
  PAGE_GALLERY: 'gallery',
  PAGE_KEYWORDS: 'keywords',
  PAGE_IMAGE: 'image',
  PAGE_VIDEO: 'video',
  PAGE_NEWS: 'news',
  PAGE_BRANDS: 'brands',
  PAGE_USER_EMAIL_VALIDATION: 'user_email_validation',
  PAGE_RETURN_CLOTHING: 'return_clothing',
}
